import {
  applySpec,
  flow,
  get,
  ifElse,
  isUndefined,
  negate,
  stubFalse,
  toDefaultEmptyString,
} from '@logistics-frontend/utils'

import type {PointContact, SearchedSddClaimRoutePoint} from '../types'

export const toPointContact: (routePoint?: SearchedSddClaimRoutePoint) => PointContact = applySpec<PointContact>({
  email: flow(get('contact.email'), toDefaultEmptyString),
  name: flow(get('contact.name'), toDefaultEmptyString),
  phone: flow(get('contact.phone'), toDefaultEmptyString),
  isSmsConfirmationEnabled: flow(get('skip_confirmation'), ifElse(isUndefined, stubFalse, negate(Boolean))),
})
